import NextLink from 'next/link';
import { tv } from 'tailwind-variants';

const styles = tv({
  base: [
    'bg-blue-500',
    'font-bold',
    'px-1',
    'rounded-sm',
    'text-white',
    'tracking-widest',
    'uppercase',
  ],
});

export default function ProFlag({ className, isLink, title }) {
  const flag = (
    <span className={styles({ class: className })} title={title}>
      Pro
    </span>
  );

  return isLink ? <NextLink href="/pro">{flag}</NextLink> : flag;
}
